
define('ldsh!modules/lp_leads/templates/lead_listing_empty_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<td data-i18n="landingPage.dialog.leadListing.emptyList">Todavía no se ha recogido ningún registro en esta Landing Page. Asegúrate que está publicada y que está llegando tráfico a ella.</td>\n';

}
return __p
};});

